import React from "react";
import { Table, Pagination, Space, Typography, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useNotification } from "../../contexts/NotificationProvider";
import { Link } from "react-router-dom";
const { Text } = Typography;
const itemRender = (_, type, originalElement) => {
  if (type === "prev") {
    return <Link>Previous</Link>;
  }
  if (type === "next") {
    return <Link>Next</Link>;
  }
  return originalElement;
};
const DataTable = ({
  columns,
  rows,
  currentPage,
  setCurrentPage,
  totalResults,
  pageSize,
  showSizeChanger,
  selectable = false,
  onDeleteSelected,
  rowKey = "_id",
  deleteAllText,
  deleteSelectedText,
  entities,
  onRowSelect
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const notify = useNotification();
  // ✅ Handles row selection
  const rowSelection = selectable
    ? {
        selectedRowKeys,
        onChange: (selectedKeys) => {
          setSelectedRowKeys(selectedKeys);
          if(onRowSelect) onRowSelect(selectedKeys)
        },
        getCheckboxProps: (record) => ({
          // Column configuration not to be checked
          name: record[rowKey],
        }),
        onSelectAll: (selected, selectedRows, changeRows) => {
          const keys = selected
            ? [
                ...new Set([
                  ...selectedRowKeys,
                  ...changeRows.map((row) => row[rowKey]),
                ]),
              ]
            : selectedRowKeys.filter(
                (key) => !changeRows.some((row) => row[rowKey] === key)
              );
          setSelectedRowKeys(keys);
        },
      }
    : null;
  const paginatedData = rows || [];
  const hasSelectedRows = selectedRowKeys.length > 0;
  const handleDelete = async () => {
    try {
      await onDeleteSelected(
        hasSelectedRows ? selectedRowKeys : null,
        entities
      );
      // Clear the selection after successful deletion
      setSelectedRowKeys([]);
    } catch (error) {
      notify({
        type: "error",
        message: "Error",
        description: "Failed to delete selected resources." || error.message,
      });
    }
  };
  return (
    <>
      {selectable && typeof onDeleteSelected === "function" && rows?.length > 0 && (
        <div style={{ padding: "5px" }}>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={handleDelete}
            style={{
              background: "red",
              color: "#fff",
              marginLeft: "auto",
              display: "flex",
            }}
          >
            {hasSelectedRows
              ? `${deleteSelectedText} (${selectedRowKeys.length})`
              : deleteAllText}
          </Button>
        </div>
      )}

      <Table
        columns={columns}
        dataSource={paginatedData}
        pagination={false}
        rowKey={rowKey}
        scroll={{ x: "max-content" }}
        rowSelection={rowSelection}
      />
      <Space
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: "16px 16px",
        }}
        wrap={true}
      >
        <Text>
          {totalResults !== 0
            ? `Showing ${(currentPage - 1) * pageSize + 1} to ${Math.min(
                currentPage * pageSize,
                totalResults
              )} of ${totalResults} entries`
            : "No entries to show"}
        </Text>
        <Pagination
          className="custom-pagination"
          defaultPageSize={pageSize}
          defaultCurrent={currentPage}
          current={currentPage}
          onChange={(page) => setCurrentPage(page)}
          total={totalResults}
          pageSize={pageSize}
          showSizeChanger={showSizeChanger}
          itemRender={itemRender}
          showLessItems={true}
        />
      </Space>
    </>
  );
};

export default DataTable;
